import { ActionIcon, Popover, TextInput } from "@mantine/core";
import React, { useContext, useState, useRef } from "react";
import { IconCode } from "@tabler/icons";
import { DataFlowContext } from "../../core/context/DataFlowContext";

const VariableSelectWrite = ({ label, placeholder, dataState='', handleData=()=>{}, handleSelect=()=>{}, description, className, style, disabled, onValueChange=()=>{}, ...props }) => {
    const [openDropdown, setOpenDropdown] = useState(false)
    const textareaRef = useRef(null);
    const dataSelect = useContext(DataFlowContext)
    const handleDropdown = () => {
        setOpenDropdown(!openDropdown)
    }

    const onInputChange = (event) => {
        handleData(event)
        event.newValue =event.target.value
        onValueChange(event)
    }

    const onClickItem = (event, item) => {
        const textarea = textareaRef.current;
        const startPos = textarea.selectionStart;
        const firstPart = dataState.toString().slice(0, startPos);
        const secondPart = dataState.toString().slice(startPos);
        const newValue = firstPart + "${" + item.value + "}" + secondPart
        event.newValue = newValue
        event.target.name = props.name
        handleSelect(event)
        onValueChange(event)
        setTimeout(() => {
            textarea.focus();
            textarea.setSelectionRange(startPos + item.value.length + 4, startPos + item.value.length + 3);
        }, 0);
        setOpenDropdown(false)
    }

    const rightSection = (<ActionIcon onClick={handleDropdown} variant="filled" color="yellow" ><IconCode size={16} /></ActionIcon>)
    return (
        <>
            <Popover disabled={disabled} opened={openDropdown} width="target" position="bottom" shadow="md">
                <Popover.Target>
                    <TextInput
                        {...props}
                        style={style}
                        className={className}
                        placeholder={placeholder}
                        value={dataState}
                        label={label}
                        disabled={disabled}
                        ref={textareaRef}
                        mt="xs"
                        description={description}
                        onChange={onInputChange}
                        rightSection={rightSection}
                    />
                </Popover.Target>
                <Popover.Dropdown
                    style={{ maxHeight: '40vh', overflow: 'auto' }}
                >
                    {dataSelect.nodeValue.variables.map((ele, index) => {
                        return (
                            <li
                                key={index}
                                onClick={(e) => onClickItem(e, ele)}
                                value={ele.value}
                            >
                                {ele.label}
                            </li>
                        )
                    })}
                </Popover.Dropdown>
            </Popover>
        </>
    )
}

export default VariableSelectWrite;